import { SchoolBankAccount } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    schoolBankAccount: {},
  },
  actions: {
    async fetch({ commit }, params) {
      const res = await SchoolBankAccount.fetch({ params })
      commit('setSchoolBankAccount', res)
    },
    async update({ commit }, params) {
      await SchoolBankAccount.update(params)
    },
  },
  mutations: {
    setSchoolBankAccount(state, data) {
      state.schoolBankAccount = data
    },
  },
}
